import React from "react"

class TopicCategories extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      canScrollLeft: false,
      canScrollRight: true
    }
    this.sliderRef = null
    this.handleScrollLeft = this.handleScrollLeft.bind(this)
    this.handleScrollRight = this.handleScrollRight.bind(this)
    this.checkScrollPosition = this.checkScrollPosition.bind(this)
  }

  componentDidMount() {
    if (this.sliderRef) {
      this.sliderRef.addEventListener('scroll', this.checkScrollPosition)
      this.checkScrollPosition() // Initial check
    }
  }

  componentWillUnmount() {
    if (this.sliderRef) {
      this.sliderRef.removeEventListener('scroll', this.checkScrollPosition)
    }
  }

  // Helper function to format numbers
  formatNumber(num) {
    if (!num) return "0"
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M'
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K'
    }
    return num.toString()
  }

  // Check scroll position and update navigation state
  checkScrollPosition() {
    if (this.sliderRef) {
      const { scrollLeft, scrollWidth, clientWidth } = this.sliderRef
      this.setState({
        canScrollLeft: scrollLeft > 0,
        canScrollRight: scrollLeft < scrollWidth - clientWidth - 1
      })
    }
  }

  // Scroll left function
  handleScrollLeft() {
    if (this.sliderRef) {
      const cardWidth = 280 + 16 // card width + gap
      this.sliderRef.scrollBy({
        left: -cardWidth * 2,
        behavior: 'smooth'
      })
    }
  }

  // Scroll right function
  handleScrollRight() {
    if (this.sliderRef) {
      const cardWidth = 280 + 16 // card width + gap
      this.sliderRef.scrollBy({
        left: cardWidth * 2,
        behavior: 'smooth'
      })
    }
  }

  render() {
    const { categories = [], stats = {} } = this.props
    const { canScrollLeft, canScrollRight } = this.state

    // Process categories data to extract main categories (level 1) - show ALL categories
    const processedCategories = categories
      .filter(categoryItem => {
        // Show all level 1 categories, regardless of thread count
        return categoryItem.category && categoryItem.category.level === 1
      })
      .map(categoryItem => {
        const category = categoryItem.category
        const threadCount = categoryItem.threads || 0
        const postCount = categoryItem.posts || 0
        
        return {
          id: category.id,
          name: category.name,
          color: category.color || "#6b7280", // Use backend color or default
          zones: this.formatNumber(threadCount),
          posts: this.formatNumber(postCount),
          description: category.description || '',
          url: category.absolute_url || `/c/${category.slug}/${category.id}/`,
          hasActivity: threadCount > 0 || postCount > 0
        }
      })

    // If no categories available, show a message
    if (processedCategories.length === 0) {
      return (
        <div className="topic-categories">
          <h2 className="categories-title">Our topics</h2>
          <div className="categories-empty">
            <p>No topics available at the moment.</p>
          </div>
        </div>
      )
    }

    return (
      <div className="topic-categories topic-categories-slider">
        <div className="categories-header">
          <h2 className="categories-title">Our topics</h2>
          <div className="slider-navigation">
            <button 
              className={`nav-button nav-left ${!canScrollLeft ? 'disabled' : ''}`}
              onClick={this.handleScrollLeft}
              disabled={!canScrollLeft}
              title="Scroll left"
            >
              <span className="material-icon">chevron_left</span>
            </button>
            <button 
              className={`nav-button nav-right ${!canScrollRight ? 'disabled' : ''}`}
              onClick={this.handleScrollRight}
              disabled={!canScrollRight}
              title="Scroll right"
            >
              <span className="material-icon">chevron_right</span>
            </button>
          </div>
        </div>
        
        <div 
          className="categories-slider" 
          ref={(ref) => { this.sliderRef = ref }}
        >
          {processedCategories.map((category) => (
            <a 
              key={category.id}
              href={category.url}
              className="category-card category-slide"
              style={{ '--category-color': category.color }}
              title={category.description}
            >
              <div className="category-header">
                <h3 className="category-name">{category.name}</h3>
                <div 
                  className="category-indicator"
                  style={{ backgroundColor: category.color }}
                />
              </div>
              
              <div className="category-stats">
                <div className="stat-item">
                  <span className="stat-value">{category.zones}</span>
                  <span className="stat-label">Zones</span>
                </div>
                <div className="stat-item">
                  <span className="stat-value">{category.posts}</span>
                  <span className="stat-label">Posts</span>
                </div>
              </div>
              
              {/* {category.hasActivity && (
                <div className="category-activity">
                  <span className="activity-indicator"></span>
                  <span className="activity-label">Active</span>
                </div>
              )} */}
            </a>
          ))}
        </div>
      </div>
    )
  }
}

export default TopicCategories